import React, { useEffect } from 'react';
import { getParamFromUrl } from '@fff-web/fff-utilities';
import useUserChoices from '../../../components/YourChoices/useUserChoices';
import { getUserMetaData, ProductChoice } from '../../../utils/Data/customizeConnector';
import { redirectToGtb } from '../../../utils/redirectionUtilities';
import { useSharedContext } from './SharedContext';

type GTBCheckoutContextProps = {
  choices: ProductChoice[];
  cartId?: number
};

export const GTBCheckoutContext = React
  .createContext<GTBCheckoutContextProps | undefined>(undefined);

type Props = {
  children: any;
};

// Make sure to use GTBCheckoutProvider one level up from where you want to consume values
const GTBCheckoutProvider = (props: Props) => {
  const { children } = props;
  const { prospect, setProspect, setInitialLoading } = useSharedContext();
  const choices = useUserChoices();
  const urlPlanCode = getParamFromUrl('planCode');

  const handleUserLocation = (zipCode: string, country: string, selectedPlan: string) => {
    if (!zipCode || !country || !selectedPlan) {
      redirectToGtb();
    }
  };

  useEffect(() => {
    Promise.resolve(getUserMetaData())
      .then((response) => {
        const { email, shipping } = response.data;
        const { country, state, zipCode } = shipping;
        const address = {
          ...prospect.address, shipState: state, shipCountry: country, shipZipCode: zipCode,
        };
        setProspect({ ...prospect, address, email });
        handleUserLocation(zipCode, country, urlPlanCode);
        setInitialLoading(false);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
  }, []);

  return (
    <GTBCheckoutContext.Provider value={{ choices }}>
      {children}
    </GTBCheckoutContext.Provider>
  );
};

export function useGTBCheckoutContext() {
  const context = React.useContext(GTBCheckoutContext);
  if (!context) {
    throw new Error(
      'You must use the GTBCheckout Provider in order to consume this context.',
    );
  }
  return context;
}

export default GTBCheckoutProvider;
